var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 18.3327C5.39783 18.3327 1.66699 14.6018 1.66699 9.99935C1.66699 5.39685 5.39783 1.66602 10.0003 1.66602C14.6028 1.66602 18.3337 5.39685 18.3337 9.99935C18.3337 14.6018 14.6028 18.3327 10.0003 18.3327ZM10.0003 16.666C11.7684 16.666 13.4641 15.9636 14.7144 14.7134C15.9646 13.4632 16.667 11.7675 16.667 9.99935C16.667 8.23124 15.9646 6.53555 14.7144 5.2853C13.4641 4.03506 11.7684 3.33268 10.0003 3.33268C8.23222 3.33268 6.53652 4.03506 5.28628 5.2853C4.03604 6.53555 3.33366 8.23124 3.33366 9.99935C3.33366 11.7675 4.03604 13.4632 5.28628 14.7134C6.53652 15.9636 8.23222 16.666 10.0003 16.666ZM10.8337 8.74935V12.4993H11.667V14.166H8.33366V12.4993H9.16699V10.416H8.33366V8.74935H10.8337ZM11.2503 6.66602C11.2503 6.99754 11.1186 7.31548 10.8842 7.5499C10.6498 7.78432 10.3318 7.91602 10.0003 7.91602C9.66881 7.91602 9.35086 7.78432 9.11644 7.5499C8.88202 7.31548 8.75033 6.99754 8.75033 6.66602C8.75033 6.3345 8.88202 6.01655 9.11644 5.78213C9.35086 5.54771 9.66881 5.41602 10.0003 5.41602C10.3318 5.41602 10.6498 5.54771 10.8842 5.78213C11.1186 6.01655 11.2503 6.3345 11.2503 6.66602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.4fe15aeea6c7096922e5a3d034b9dd10.svg";
export { ForwardRef as ReactComponent };